import { FC, useEffect, useState } from 'react'
import PopupContainer from 'src/component/popup/PopupContainer'
import { errorToaster } from 'src/utils'
import DynamisServiceCard from './DynamisServiceCard'
import { useMutation } from 'src/hooks/useMutation'
import { SubmitNewDiagnosis } from 'src/requests/PatientMedicalHistory'
import { Lookup } from 'src/common/Common.Type'
import DropDown from 'src/component/DropDown'

interface IMedicalServicesPopup {
    paitentId: number | null
    hospitalList: Lookup[]
    modalId: any
    setPatientId: any
    setHospitalId?:Function 
    hospitalId: number | null
}

const medicalService = 'medicalService'


const CMedicialNotesPopup: FC<IMedicalServicesPopup> = ({setHospitalId, paitentId, setPatientId, hospitalList, modalId }) => {

    const [data, setData] = useState([{ notes: "", diseaseName: null }])
    const [hospital, setHospital] = useState(hospitalList[hospitalList?.length - 1] || null)


    useEffect(() => {
        setHospital(hospitalList[hospitalList?.length - 1] || null)

    }, [hospitalList])

    const { mutate } = useMutation()

    const handleSubmit = () => {
        let isAnyEmpty = data?.some((item: any) =>  !item?.diseaseName)
        if (isAnyEmpty) return errorToaster("add-item-atlist")



        let requestBody = {
            patientId: paitentId,
            hospitalId: hospital?.value,
            diagnosis: [...data]
        }

        let ReuqestObject = {
            apiMethod: SubmitNewDiagnosis,
            body: requestBody,
            actionType: 'post',
            id: null,
            onSuccess: () => onSuccess(),
            name: "add-medical-diagnosis",
        }
        //@ts-ignore
        mutate(ReuqestObject)
    }

    const onSuccess = () => {

        modalId.current.click()
        setData([{ notes: "", diseaseName: null }])
        setPatientId(null)
        setHospitalId &&setHospitalId(null) 
    }


    return (
        <PopupContainer Name='add-medical-note' recordID={paitentId} modalID={modalId} modalName={medicalService} onApply={handleSubmit}>
            {
                hospitalList?.length > 1 &&
                <DropDown label='hospital' options={hospitalList} setVal={setHospital} val={hospital} placeholder={"hospital"} />
            }
            <DynamisServiceCard fieldName={"analysis"} data={data} setData={setData} />
        </PopupContainer>
    )
}

export default CMedicialNotesPopup